module.exports = __webpack_public_path__ + "img/electro.fa86f2a8.jpg";